module.exports = __webpack_public_path__ + "img/2.1bb0ad81.jpeg";